import Typography from "@mui/material/Typography";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import { parseEscapedNewlines } from "../../../../../../../helpers/et3-conversation-parse";

const KhattabatMessageText = withLiteObserverAndTheme<{ text: string }>(
  (props) => (
    <Typography
      variant="body2"
      sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
    >
      {parseEscapedNewlines(props.text)}
    </Typography>
  )
);

export default KhattabatMessageText;
